import { LabelHTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    text?: string
    required?: boolean
}

export function Label({ text, required, ...rest }: LabelProps) {
    return (
        <label
            {...rest} className={twMerge("tw-justify-start tw-items-start tw-text-azulescuro tw-font-semibold tw-text-sm tw-mb-1", rest.className)}>
            {text}
            {required && <span className="tw-text-primary"> *</span>}
        </label>
    )
}
